<div class="main pt-3">
  <div class="container" style="max-width: 1400px">
    <div class="row spacing-20">
      <app-user-profile-header
        [user]="user"
        class="p-0"
      />
    </div>

    <!-- Modern Tab Navigation -->
    <div class="profile-tabs-wrapper">
      <div class="profile-tabs">
        <button class="profile-tab" [class.active]="selectedTab === 'overview'" (click)="selectedTab = 'overview'">
          <i class="fa fa-user me-2"></i>
          <span>{{ 'userProfile.tabs.overview' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'horses'" (click)="selectedTab = 'horses'">
          <i class="fa fa-horse me-2"></i>
          <span>{{ 'userProfile.tabs.horses' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'events'" (click)="selectedTab = 'events'">
          <i class="fa fa-calendar-check me-2"></i>
          <span>{{ 'userProfile.tabs.events' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'my-events'" (click)="selectedTab = 'my-events'">
          <i class="fa fa-clipboard-user me-2"></i>
          <span>{{ 'userProfile.tabs.myEvents' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'results'" (click)="selectedTab = 'results'">
          <i class="fa fa-trophy me-2"></i>
          <span>{{ 'userProfile.tabs.results' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'membership'" (click)="selectedTab = 'membership'">
          <i class="fa fa-id-card me-2"></i>
          <span>{{ 'userProfile.tabs.membership' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'organisations'" (click)="selectedTab = 'organisations'">
          <i class="fa fa-building me-2"></i>
          <span>{{ 'userProfile.tabs.organisations' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'orders'" (click)="selectedTab = 'orders'">
          <i class="fa fa-receipt me-2"></i>
          <span>{{ 'userProfile.tabs.orders' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'invoices'" (click)="selectedTab = 'invoices'">
          <i class="fa fa-file-invoice me-2"></i>
          <span>{{ 'userProfile.tabs.invoices' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'trainer'" (click)="selectedTab = 'trainer'">
          <i class="fa fa-chalkboard-teacher me-2"></i>
          <span>{{ 'userProfile.tabs.trainer' | translate }}</span>
        </button>
      </div>
    </div>
    @if (selectedTab == 'overview') {
      <app-user-profile-overview
        [user]="user"
        class="p-0"
      />
    }
    @else if (selectedTab == 'horses') {
      <app-user-profile-horses
        [user]="user"
        class="p-0"
      />
    }
    @else if (selectedTab == 'events') {
      <app-user-profile-shows [user]="user" class="p-0" />
    }
    @else if (selectedTab == 'my-events') {
      <app-user-profile-my-events class="p-0" />
    }
    @else if (selectedTab == 'results') {
      <app-user-results [user]="user" class="p-0" />
    }
    @else if (selectedTab == 'membership') {
     <app-user-profile-membership
      [user]="user"
      class="p-0"
     />
    }
    @else if (selectedTab == 'organisations') {
     <app-user-profile-organisations
      [user]="user"
      class="p-0"
     />
    }
    @else if (selectedTab == 'orders') {
      <app-user-profile-orders [user]="user" class="p-0" />
    }
    @else if (selectedTab == 'invoices') {
      <app-user-profile-invoices class="p-0" />
    }
    @else if (selectedTab == 'trainer') {
      <app-user-profile-trainer class="p-0" />
    }
  </div>
</div>
